import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import ValidationResult from './ValidationResult';

const StyledList = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-height: 350px;
    overflow-y: auto;
`;

const Results = (props) => {
    const { results } = props;

    if (utils.isEmpty(results)) {
        return null;
    }

    return (
        <StyledList>
            { utils.map(results, function (value, name) {
                return <ValidationResult key={ name } name={ name } value={ value } { ...props } />;
            }) }
        </StyledList>
    );
};

Results.propTypes = {
    results: PropTypes.object,
};

export default translate(Results);



// WEBPACK FOOTER //
// ./src/pages/products/productAvailibity/Results.js